import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { CheckCircle2, XCircle, ArrowRight } from "lucide-react";

export default function AvantagesInconvenients() {
  const avantagesV = [
    "Bouquet immédiat : capital versé le jour de la signature notariée",
    "Mensualités fixes pendant toute la durée du contrat (5 à 30 ans)",
    "Aucun aléa de durée de vie : la durée est fixée d'avance",
    "En cas de décès, les mensualités continuent au profit des héritiers",
    "Hypothèque légale spéciale (art. 2402 du Code civil) + clause résolutoire",
    "Fiscalité favorable : mensualités non imposables au titre de l'IR",
  ];
  const inconvenientsV = [
    "Rendement dépendant de la qualité de l'acheteur",
    "Nécessité d'accepter un paiement étalé (5 à 30 ans)",
    "Prix ferme : pas de revalorisation en cas de flambée du marché",
    "Sélection rigoureuse de l'acheteur indispensable",
  ];
  const avantagesA = [
    "Aucun crédit bancaire, aucun taux d'intérêt",
    "Propriétaire dès la signature de l'acte notarié",
    "Prix ferme, sans indexation ni révision",
    "Alternative viable pour profils sans accès au crédit classique",
    "Étalement sur longue durée (5 à 30 ans)",
  ];
  const inconvenientsA = [
    "Nécessite un apport (le bouquet, souvent 10 à 40 %)",
    "Engagement long : mensualités jusqu'au terme",
    "Bien libre uniquement si vente « libre »",
    "Requalification possible si mensualités anormalement basses ou courtes",
  ];

  return (
    <>
      <SEO
        title="Avantages et inconvénients de la vente à terme — venteaterme.fr"
        description="Analyse honnête des avantages et inconvénients de la vente à terme pour vendeur et acheteur. Fiscalité, protections, engagement."
      />
      <section className="pt-24 pb-10 bg-navy text-cream">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-accent-brand font-bold mb-4">Éclairage</div>
          <h1 className="font-serif text-4xl md:text-6xl leading-tight">Avantages &amp; inconvénients de la vente à terme</h1>
          <p className="text-cream/80 mt-6 max-w-3xl">Une analyse équilibrée pour comprendre à qui la vente à terme convient — et à qui elle ne convient pas.</p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-6">
          {[
            { title: "Pour le vendeur", pros: avantagesV, cons: inconvenientsV, dark: true },
            { title: "Pour l'acheteur", pros: avantagesA, cons: inconvenientsA, dark: false },
          ].map((c, i) => (
            <div key={i} className={`p-8 md:p-10 border ${c.dark ? "bg-navy text-cream border-navy" : "bg-white border-navy/10"}`}>
              <h2 className={`font-serif text-2xl mb-6 ${c.dark ? "text-cream" : "text-navy"}`}>{c.title}</h2>
              <div className={`text-xs uppercase tracking-widest font-bold mb-3 ${c.dark ? "text-accent-brand" : "text-accent-brand"}`}>Avantages</div>
              <ul className="space-y-2 mb-8">
                {c.pros.map((p, j) => (
                  <li key={j} className={`flex items-start gap-2 text-sm ${c.dark ? "text-cream/85" : "text-navy/80"}`}>
                    <CheckCircle2 size={16} className="text-accent-brand shrink-0 mt-0.5" /><span>{p}</span>
                  </li>
                ))}
              </ul>
              <div className={`text-xs uppercase tracking-widest font-bold mb-3 ${c.dark ? "text-cream/60" : "text-navy/60"}`}>Points de vigilance</div>
              <ul className="space-y-2">
                {c.cons.map((p, j) => (
                  <li key={j} className={`flex items-start gap-2 text-sm ${c.dark ? "text-cream/70" : "text-navy/70"}`}>
                    <XCircle size={16} className="text-navy/40 shrink-0 mt-0.5" /><span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto text-center px-6">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-4">Envie de savoir combien vous pouvez obtenir&nbsp;?</h2>
          <p className="text-navy/70 mb-8">Notre simulateur calcule votre bouquet et vos mensualités en 30 secondes.</p>
          <Link to="/simulateur" className="inline-flex items-center gap-2 bg-accent-brand text-white px-8 py-3 font-bold tracking-wide hover:bg-[#B08D22] transition-colors">
            Simuler mon opération <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </>
  );
}
